module.exports = __webpack_public_path__ + "img/Papermaking_stock.33fca320.svg";